import React, { FC } from 'react';
import { Skeleton } from '@mui/material';
import { StyledTitle } from './styles';
import { ITitle } from './types';

const Title: FC<ITitle> = props => {
  const { title } = props;

  return (
    <StyledTitle variant="h1">
      {title || <Skeleton height={50} variant="text" width={550} />}
    </StyledTitle>
  );
};

export default Title;
